import { Component } from '@angular/core';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-ab-routing-sub-nav',
  templateUrl: './enterprise-ab-routing-sub-nav.component.html',
  standalone: false,
})
export class EnterpriseAbRoutingSubNavComponent extends SubNavBaseComponent {}
